export interface IVxmAnalysis {
    recipientCenterId: number,
    recipientCenter: string,
    vxmCount: number,
    wasAcceptedNoIssuesCount: number,
    wasDeclinedUnacceptableCount: number,
    wasAcceptedNotConfidentCount: number,
    wasDeclinedUnacceptableAbove99cpraCount: number,
    wasAcceptedNotConfidentAbove99cpraCount: number,
    acceptableCount: number,
    unacceptableCount: number,
    successRate: number,
    failureRate: number,
    rank: number,
    category: string,
    sortType: string,
    sort: number
}